import { axios } from '@/utils/request'

/**
 * 还款列表查询
 */
export function getRepaymentList(parameter = {}) {
  return axios({
    url: '/flowRepayInfo/list',
    method: 'post',
    data: parameter
  })
}

/**
 * 还款列表导出
 */
export function exportRepaymentList(parameter = {}) {
  return axios({
    url: '/flowRepayInfo/export',
    method: 'post',
    data: parameter,
    responseType: 'blob'
  })
}

/**
 * 还款数据处理
 */
export function processFailRepay(parameter = {}) {
  return axios({
    url: '/flowRepayInfo/processFailRepay',
    method: 'post',
    data: parameter
  })
}
